import { render, staticRenderFns } from "./ReasonableAccommodation.vue?vue&type=template&id=49edbbb4&"
import script from "./ReasonableAccommodation.vue?vue&type=script&lang=js&"
export * from "./ReasonableAccommodation.vue?vue&type=script&lang=js&"
import style0 from "./ReasonableAccommodation.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports